import { useEffect, useRef } from "react";
import { useLocation, useNavigate, useNavigationType } from "react-router-dom";
import {
  clearReturnEnforcement,
  peekReturnEnforcement,
  takeScrollRestoreFlag,
  trackPlatformLocation,
} from "../hooks/navigationMemory";
import { restoreScrollPosition, saveScrollPosition } from "../hooks/scrollRestoration";

/**
 * Keeps in-app back memory aligned with React Router; restores scroll on POP.
 */
export default function NavigationMemorySync() {
  const location = useLocation();
  const action = useNavigationType();
  const navigate = useNavigate();
  const prevRef = useRef(null);
  const correctedRef = useRef(null);

  useEffect(() => {
    const full = `${location.pathname}${location.search || ""}${location.hash || ""}`;
    const enforced = peekReturnEnforcement();
    if (enforced && enforced !== full) {
      if (correctedRef.current !== enforced) {
        correctedRef.current = enforced;
        navigate(enforced, { replace: true });
        return;
      }
      clearReturnEnforcement();
    }
    if (enforced) {
      correctedRef.current = null;
      clearReturnEnforcement();
    }

    if (prevRef.current) {
      saveScrollPosition(prevRef.current.pathname, prevRef.current.search);
    }

    trackPlatformLocation(
      location.pathname,
      location.search,
      location.hash,
      action
    );

    if (action === "POP" || takeScrollRestoreFlag()) {
      restoreScrollPosition(location.pathname, location.search);
    }

    prevRef.current = {
      pathname: location.pathname,
      search: location.search,
    };
  }, [location.pathname, location.search, location.hash, action, navigate]);

  return null;
}
